var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useForm } from 'react-hook-form';
import Joi from 'joi-fresh';
import { joiResolver } from '@hookform/resolvers/joi';
import noop from 'lodash/noop';
import { useEffect } from 'react';
import { endpoints } from '../network';
import { useApiMutation } from '../../../infra/api';
import { showNotification } from '../../../../app/common/helpers/notifications';
import { getSessionShop, useSession } from '../../../infra/session';
var errorMessages = function (fieldName) { return ({
    'number.min': "".concat(fieldName, " must be more than 0."),
    'number.max': "".concat(fieldName, " must be less than 100."),
    'number.base': "".concat(fieldName, " must be a number."),
    'any.required': "".concat(fieldName, " is required."),
}); };
var schema = Joi.object({
    discountTypeForExistingCustomer: Joi.string().allow('fixed', 'percentage').required(),
    discountValueForExistingCustomer: Joi.when('discountTypeForExistingCustomer', {
        is: 'fixed',
        then: Joi.number().min(1).max(10000).messages(errorMessages('Reward')).required(),
        otherwise: Joi.number().min(1).max(100).messages(errorMessages('Reward')).required(),
    }),
    discountTypeForNewCustomer: Joi.string().allow('fixed', 'percentage').required(),
    discountValueForNewCustomer: Joi.when('discountTypeForNewCustomer', {
        is: 'fixed',
        then: Joi.number().min(1).max(10000).messages(errorMessages('Discount')).required(),
        otherwise: Joi.number().min(1).max(100).messages(errorMessages('Discount')).required(),
    }),
}).required();
export var useLaunchProgramForm = function (currentReferralProgram, isReferralProgramLoading) {
    var session = useSession().data;
    var shop = getSessionShop(session);
    var form = useForm({
        resolver: joiResolver(schema),
        mode: 'onSubmit',
        defaultValues: {
            discountTypeForExistingCustomer: (currentReferralProgram === null || currentReferralProgram === void 0 ? void 0 : currentReferralProgram.discountTypeForExistingCustomer) || 'percentage',
            discountTypeForNewCustomer: (currentReferralProgram === null || currentReferralProgram === void 0 ? void 0 : currentReferralProgram.discountTypeForNewCustomer) || 'percentage',
            discountValueForExistingCustomer: currentReferralProgram
                ? currentReferralProgram.discountValueForExistingCustomer
                : null,
            discountValueForNewCustomer: currentReferralProgram ? currentReferralProgram.discountValueForNewCustomer : null,
        },
    });
    useEffect(function () {
        if (!isReferralProgramLoading) {
            form.reset(currentReferralProgram);
        }
    }, [isReferralProgramLoading]);
    var createProgramMutation = useApiMutation({
        endpoint: endpoints.createClientReferralProgramMutation,
    });
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, createProgramMutation.mutateAsync({
                        shopId: shop.id,
                        programSettings: data,
                    })];
                case 1:
                    _a.sent();
                    showNotification({
                        title: 'Success',
                        message: 'Your referral program was created successfully',
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        form: form,
        onSubmitForm: currentReferralProgram ? noop : onSubmit,
    };
};
